import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import Loader from '../../components/loader';

class ConfirmAutomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termsAgree: false,
    };
    this.handleCheckToggle = this.handleCheckToggle.bind(this);
  }

  handleCheckToggle(item) {
    const { termsAgree } = this.state;
    this.setState({ termsAgree: !termsAgree });
  }

  componentDidMount() {
  }

  componentDidUpdate() {
  }

  render() {
    const { user, errors, success, assets, assetDeposit, assetBuy, handleCreateAutomation } = this.props;
    const { termsAgree } = this.state;

    let depAssetName;

    if (assets && assets.length && assetDeposit) {
      depAssetName = assets.find(e => e.handle === assetDeposit);
    }

    if (depAssetName && depAssetName.name) {
      depAssetName = depAssetName.name;
    }


    const buyLoop = assetBuy && assetBuy.length && assetBuy.map((buy, index) => {
      const key = `buy-${index}`;

      let buyAssetName;

      if (assets && assets.length && buy.asset) {
        buyAssetName = assets.find(e => e.handle === buy.asset);
      }

      if (buyAssetName && buyAssetName.name) {
        buyAssetName = buyAssetName.name;
      }

      return (
        <div key={key} className="flex-container align-middle" style={{marginBottom: 8}}>
          <div style={{
            marginRight: 32,
            color: '#2c40c3',
            fontWeight: 'bold'
          }}>
            {buy.percentage}%
          </div>
          <div className={`vlt-coin ${buyAssetName.replace(/\s/g, "-").toLowerCase()}`}>
            <img alt={buyAssetName} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${buyAssetName.replace(/\s/g, "-").toLowerCase()}.svg`} />
          </div>
          <div style={{marginLeft: 8}}>
            {buy.asset}
          </div>
        </div>
      );
    });

    return (
      <div className="cell small-12 medium-12 large-12 automation-modal">
        <div className="modal-heading">
          Create Trading Automation
        </div>
        <div>
          <p>This will create a new <b>{depAssetName}</b> automation wallet. When you deposit to this wallet, it will carry out the trades you have requested.</p>
          <p>Ensure you are sending enough <b>{depAssetName}</b> to meet the minimum order amounts for the assets you are buying.</p>
          <p>If any orders fail, the leftover <b>{depAssetName}</b> will be deposited into your Vaultoro wallet.</p>
        </div>
        <div className="grid-x modal-body">
          <div className="cell small-12 medium-12 large-12">
            <hr />
            <div className="lr-p lr-p--top">
              <div style={{marginTop: 5}}>
                <b>When I deposit:</b>
              </div>
              <div className="flex-container align-middle">
                <div className={`vlt-coin ${depAssetName.replace(/\s/g, "-").toLowerCase()}`}>
                  <img alt={depAssetName} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${depAssetName.replace(/\s/g, "-").toLowerCase()}.svg`} />
                </div>
                <div style={{marginLeft: 8}}>
                  {assetDeposit || ''}
                </div>
              </div>
            </div>
            <hr />
            <div className="lr-p lr-p--top">
              <div style={{marginTop: 0}}>
                <b>I want to buy:</b>
              </div>
              <div>
                {buyLoop}
              </div>
            </div>
            <hr />
          </div>
        </div>
        <div className="cell small-12 medium-12 large-12 modal-actions">
          <div className="checkbox-wrapper">
            <div
              className={termsAgree ? 'cb-check true' : 'cb-check'}
              style={{alignItems: 'center'}}
              onClick={() => this.handleCheckToggle()}
            >
              <div className="cb-box" />
              <div className="cb-label">
                I agree that trade prices will be set from current fair Vaultoro market values at the time the automation is triggered.
              </div>
            </div>
          </div>
          <button
            className="button"
            type="button"
            onClick={() => this.props.toggleModal(null)}>
            <span>
              Cancel
            </span>
          </button>
          <button
            className="vlt-button"
            type="button"
            disabled={!termsAgree}
            onClick={handleCreateAutomation}
          >
            <span>
              Confirm
            </span>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  automations: state.automation.automations,
  loading: state.automation.loading,
  errors: state.automation.errors,
  success: state.automation.success,
  coins: state.coins.coins,
});

export default withRouter(connect(mapStateToProps)(ConfirmAutomation));
